export const Message = () => ({
	required: {
		text: (field) => `${field} is required.`,
		select: (field) => `Please select ${field}.`,
	},
	min: {
		string: (min, field) =>
			`${field} should contain minimum ${min} characters.`,
		select: (min, field) => `Please select minimum ${min} ${field}.`,
		numeric: (min, field) =>
			`${field} should contain minimum ${min} digits.`,
	},
	max: {
		string: (max, field) =>
			`${field} should contain maximum ${max} characters.`,
		select: (max, field) => `Please select maximum ${max} ${field}.`,
		numeric: (max, field) =>
			`${field} should contain maximum ${max} digits.`,
	},
	email: (field) => `${field} Is Invalid email.`,
	regex: {
		password: (field) =>
			`${field} should contain at least 8 character with uppercase letter, lowercase letter, number and special character.`,
		numeric: () => `Please enter digits only.`,
		decimal: (number) =>
			`Please enter digits or decimal digits upto ${number} decimal only.`,
		other: (field) => `Please enter valid ${field}.`,
	},
	global: {
		networkIssue: `Network Issue.`,
	},
	between: {
		numeric: (field, min, max) =>
			`The ${field} must be between ${min} and ${max}.`,
	},
	url: `Invalid URL.`,
	noRecord: 'No record found.',
	profile: 'Profile updated successfully.',

	CRUD: {
		ADD: (moduleName) => `${moduleName} added successfully.`,
		UPDATE: (moduleName) => `${moduleName} updated successfully.`,
		DELETE: (moduleName) => `${moduleName} deleted successfully.`,
	},

	FileProcess:
		'File uploading in the background. You can check after 2-3 minutes.',
	ImageApproved: 'Image status has been updated successfully.',
});

export default Message;
